/**
 * Утилиты для работы с authToken
 * Реализует ту же логику, что и на бэкенде
 */

/**
 * Кодирует строку с помощью XOR (аналогично логике на бэкенде)
 */
function encodeToken(data: string, secret: string): string {
  const dataBytes = new TextEncoder().encode(data);
  const secretBytes = new TextEncoder().encode(secret);
  const result = new Uint8Array(dataBytes.length);
  
  for (let i = 0; i < dataBytes.length; i++) {
    result[i] = dataBytes[i] ^ secretBytes[i % secretBytes.length];
  }
  
  // Конвертируем в base64
  return btoa(String.fromCharCode.apply(null, Array.from(result)));
}

/**
 * Создает authToken из URL параметров
 */
export function createAuthToken(): string {
  const urlParams = new URLSearchParams(window.location.search);
  const currentUrl = window.location.href;
  
  // Извлекаем параметры из URL или используем дефолтные значения
  const params: Record<string, string> = {};
  
  // Добавляем все параметры из URL
  urlParams.forEach((value, key) => {
    params[key] = value;
  });
  
  // Добавляем текущий URL если нет параметра url
  if (!params.url) {
    params.url = currentUrl;
  }
  
  // Добавляем временную метку
  if (!params.timestamp) {
    params.timestamp = Date.now().toString();
  }
  
  // Формируем строку параметров в формате key=value;key2=value2
  const tokenData = Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join(';');
  
  // Кодируем с тем же секретом, что и на бэкенде
  return encodeToken(tokenData, 'mySecretKey123');
}

/**
 * Создает authToken с определенным телефоном
 */
export function createAuthTokenWithPhone(phone: number): string {
  const urlParams = new URLSearchParams(window.location.search);
  const currentUrl = window.location.href;
  
  const params: Record<string, string> = {
    phone: phone.toString(),
    timestamp: Date.now().toString(),
    url: currentUrl
  };
  
  // Добавляем дополнительные параметры из URL
  urlParams.forEach((value, key) => {
    if (key !== 'phone') {
      params[key] = value;
    }
  });
  
  // Формируем строку параметров
  const tokenData = Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join(';');
  
  // Кодируем с тем же секретом, что и на бэкенде
  return encodeToken(tokenData, 'mySecretKey123');
}
